import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default function (params) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '/api/orders',
    name: 'GET_CUSTOMER_ORDERS',
  });

  useEffect(() => {
    if (params) {
      let url = `/api/orders`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [data || [], exec, isRequestSuccessed];
}
